import React from "react";
import "./story.css";
let defaultImg;

function Story(props) {
  return (
    <div className="story__container--main">
      <div className="story__figure--container">
        <div className="story__figure">
          <div className="home__img shadow-aboutimg dark:shadow-aboutimg"></div>
          {/* <div className="home__img_dark shadow-aboutimg dark:shadow-aboutimg"></div> */}
        </div>
      </div>
      <div className="story__content">
        <span className="story__heading">
          <div className="pb-2 section__contentTitle about__content">
            Hey, I'am{" "}
            <span className="text-titleColor dark:text-white">Pranav</span>
          </div>
        </span>
        <span className="p-2 story__para">
          Front-end web developer with over{" "}
          {new Date().getFullYear() - 2019}+ years of experience building
          scalable, responsive applications across complex product domains—from
          enterprise survey platforms to seller-facing portals. Passionate about
          modern UI architecture, performance, and shipping features that drive
          measurable impact. Proven at leading cross-team delivery, mentoring
          engineers, and establishing standards for maintainable code. I thrive
          partnering with teams to unblock bottlenecks,
          and turn ambitious roadmaps into production-ready experiences.
        </span>
      </div>
      {/* achievement */}
      <div className="flex gap-2 justify-around pt-4">
        <div className="w-36 h-20 text-center shadow-xl md:leading-tight md:text-sm">
          <div className="text-3xl font-bold text-titleColor dark:text-white">
            {String(new Date().getFullYear() - 2019).padStart(2, "0")}+
          </div>
          <div>Years</div>
          <span>experience</span>
        </div>
        <div className="w-36 h-20 text-center shadow-xl md:leading-tight md:text-sm">
          <div className="text-3xl font-bold text-titleColor dark:text-white">
            18+
          </div>
          <div>Completed</div>
          <span>projects</span>
        </div>
        <div className="w-36 h-20 text-center shadow-xl md:leading-tight md:text-sm">
          <div className="text-3xl font-bold text-titleColor dark:text-white">
            02+
          </div>
          <div>Companies</div>
          <span>Worked</span>
        </div>
      </div>
    </div>
  );
}
Story.defaultProps = {
  story__author: "Marry Smith",
  story__img: defaultImg,
  story__para:
    "Lead front-end web developer with extensive experience building scalable, responsive applications, leading delivery, mentoring engineers, and shipping high-impact product features.",
  story__heading: "Hey, I'am Pranav",
};

export default Story;
